import React from "react";
import { avatarSm } from "../../assets/index";

const Logo = ({ className = "" }) => {
  return (
    <span className={`group inline-flex items-center gap-3 ${className}`}>
      <span className="relative w-11 h-11 rounded-full p-[2px] bg-gradient-to-br from-designColor to-[#ff8a5c] shadow-lg shadow-designColor/30">
        <img src={avatarSm} alt="" className="w-full h-full rounded-full object-cover border-2 border-bodyColor" />
        <span className="absolute -right-1.5 -bottom-1 text-sm opacity-0 group-hover:opacity-100 duration-300" aria-hidden>
          👋
        </span>
      </span>
      <span className="font-titleFont text-2xl font-bold text-white tracking-wide">
        Bipin<span className="text-designColor">.</span>
      </span>
    </span>
  );
};

export default Logo;
